module.exports = __webpack_public_path__ + "img/dp-homepage.643891d7.svg";